import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchAanvraag, initialState } from '../services/fetchAanvraag'

export { useAanvraagSearch }

const queryKey = 'beheer-aanvraag'

const useAanvraagSearch = (aanvraagID: string) => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data, isFetching, error } = useQuery({
    queryFn: () => fetchAanvraag({ aanvraagID }),
    queryKey: [queryKey, aanvraagID],
    enabled: hasPermissions && !!aanvraagID,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    error,
  }
}
